/* eslint-disable */
import React from 'react';
import * as MUI from '@material-ui/core';
import { TreeItem } from '@material-ui/lab';
import { useStyles } from './styles';
import { Link } from '../../../Link';
import DocIcon from '../../../../../../icons/office/DOC';
import { historyReportsService } from '../../../../../reportng/dataFlow';


export const Slide = ({ children, to, number, ...props }) => {
  const classes = useStyles(props);
  let { color } = props;
  switch (color) {
    case 'blue': color = '#0F8AC0'; break;
    case 'green': color = '#1CA955'; break;
  }

  const partsTo = to.split('/');
  const repId = partsTo[partsTo.length - 1];
  const click = () => historyReportsService.openReport(repId, children as string);

  const Label = () => (
    <Link to={to} onClick={click}>
      <MUI.Typography component='span' variant="body1" className={classes.slideContent}>
        <div>
          <DocIcon className={classes.slideIcon} color={color} />
          {children}
        </div>
        <span className={classes.slideNumber}>{number}</span>
      </MUI.Typography>
    </Link>
  );

  return <TreeItem nodeId={children.replace(' ', '_')} label={<Label />} className={classes.slide} />;
}

export default Slide;